import React, { useEffect } from "react"
import { view } from "@risingstack/react-easy-state"
import { useParams } from "react-router-dom"
import ContentLoading from "components/common/ContentLoading"

import DocumentsService from "services/users/documents.service"

const DocumentDownloadRedirector = () => {
  const { documentUuid } = useParams()

  useEffect(() => {
    const fetchDataAndRedirect = async () => {
      const tempState = {}

      await DocumentsService.download({ pageState: tempState, documentUuid })

      const { redirect_url } = tempState

      // TODO: Handle errors. Show error messages on the same page
      if (redirect_url) window.location = redirect_url
    }
    fetchDataAndRedirect()
  }, [documentUuid])

  return <ContentLoading />
}

export default view(DocumentDownloadRedirector)
